module.exports = __webpack_public_path__ + "static/Teammates-JIRA-1413a3a550deed71d50843eb88f9fa83.png";